import webBackApi from '../../api/webBackApi';

export const getLatestImage = async (feedId) => {
  try {
    // Expecting the backend to return the direct S3 pre-signed URL as a string
    const response = await webBackApi.get(`/api/s3-images/${feedId}/latest`);
    return response.data; // This should be the direct URL string
  } catch (error) {
    console.error("Error fetching latest image:", error);
    throw error;
  }
};
